import { render, staticRenderFns } from "./ExaminationsPhase.vue?vue&type=template&id=4b8a0c49&"
import script from "./ExaminationsPhase.vue?vue&type=script&lang=js&"
export * from "./ExaminationsPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports